import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAdminDashboard({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/adminDashboard"));
  console.log("Loading", AsyncAdminDashboard.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAdminDashboard;
